import './BookDetailsTable.css'
import * as React from "react";
import {Paper, Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import {Link} from "react-router-dom";
import {formatBookName} from "../../../../Functions/Formatter";
import {isAdmin} from "../../../../Functions/Authentication";

class BookDetailsTable extends React.Component {

  render() {
    return (
        <TableContainer component={Paper} sx={{minWidth: "300px"}} className={"book-download-table"}>
          <Table>
            <TableBody>
              <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                  <b>Book</b>
                </TableCell>
                <TableCell>
                  {isAdmin() ? this.props.data.name : formatBookName(this.props.data.name)}
                </TableCell>
              </TableRow>
              <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                  <b>Author</b>
                </TableCell>
                <TableCell>
                  {this.props.data.authorName ? <Link to={"/books/browse/all?author=" + this.props.data.authorId}>{this.props.data.authorName}</Link> : "Unknown"}
                </TableCell>
              </TableRow>
              <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                  <b>Pages</b>
                </TableCell>
                <TableCell>
                  {this.props.data.pageCount.toLocaleString()}
                </TableCell>
              </TableRow>
              <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                  <b>File Size</b>
                </TableCell>
                <TableCell>
                  {this.props.data.size}
                </TableCell>
              </TableRow>
              <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                  <b>Language</b>
                </TableCell>
                <TableCell>
                  {this.props.data.languageName ? <Link to={"/books/browse/all?language=" + this.props.data.languageId}>{this.props.data.languageName}</Link> : "Unknown"}
                </TableCell>
              </TableRow>
              <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                  <b>Category</b>
                </TableCell>
                <TableCell>
                  {this.props.data.categoryName ? <Link to={"/books/browse/all?category=" + this.props.data.categoryId}>{this.props.data.categoryName}</Link> : "Unknown"}
                </TableCell>
              </TableRow>
              <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                  <b>Added</b>
                </TableCell>
                <TableCell>
                  {this.props.data.added}
                </TableCell>
              </TableRow>
              <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                  <b>Downloads</b>
                </TableCell>
                <TableCell>
                  {this.props.data.downloadCount.toLocaleString()}
                </TableCell>
              </TableRow>
              {
                isAdmin() &&
                <TableRow sx={{"&:last-child td, &:last-child th": {border: 0}}}>
                  <TableCell component="th" scope="row" sx={{minWidth: "90px"}}>
                    <b>File Name</b>
                  </TableCell>
                  <TableCell>
                    {this.props.data.fileName}
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>
    );
  }

}

export default BookDetailsTable;
